import { FunctionComponent, useState, ChangeEvent, SyntheticEvent } from "react";
import "./styles.scss";
import ReCAPTCHA from "react-google-recaptcha";
import { MessagesService } from "../../services/messages";
import Loading from "../common/Loading";
import { useAsync } from "../../utils/hooks/useAsync";

type FormData = {
  name: string;
  phoneNumber: string;
  email: string;
  company: string;
  message: string;
};

type FormValidation = {
  name: boolean;
  phoneNumber: boolean;
  email: boolean;
  message: boolean;
};

const ContactForm: FunctionComponent = ({}) => {
  const { isLoading, isSuccess, run } = useAsync();
  const [validUser, setValidUser] = useState(false);
  const [successMessage, setSuccessMessage] = useState<boolean>(false);
  const [formData, setFormData] = useState<FormData>({
    name: "",
    phoneNumber: "",
    email: "",
    company: "",
    message: "",
  });

  const [formValidation, setFormValidation] = useState<FormValidation>({
    name: true,
    phoneNumber: true,
    email: true,
    message: true,
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  function onChange() {
    setValidUser(true);
  }

  const { name, phoneNumber, email, company, message } = formData;

  const validation = {
    name: /^[a-zA-Z ]+$/.test(name),
    phoneNumber: /^\d+$/.test(phoneNumber),
    email: /^\S+@\S+\.\S+$/.test(email),
    message: message.length > 0,
  };

  const isValid = Object.values(validation).every((isValid) => isValid);

  const handleSendMessage = (e: SyntheticEvent) => {
    e.preventDefault();

    window.scrollTo({ top: 0, behavior: "smooth" });
    if (isValid) {
      setFormValidation(validation);
      run(
        MessagesService.sendMessage({
          name,
          phoneNumber,
          email,
          company,
          message,
        })
          .then((data) => {
            setSuccessMessage(true);
            resetFormData();
          })
          .catch((err) => {
            console.log(err);
          })
      );
    } else {
      setFormValidation(validation);
    }
  };

  const resetFormData = () => {
    setFormData({
      name: "",
      phoneNumber: "",
      email: "",
      company: "",
      message: "",
    });
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : successMessage ? (
        <div className="success_message">
          <h3>Listo!</h3>
          <p>Se ha enviado tu mensaje. Nos pondremos en contacto a la brevedad.</p>
        </div>
      ) : (
        <form className="contact_form_container" onSubmit={handleSendMessage}>
          <label htmlFor="name" className="contact_form_label">
            Nombre y apellido
          </label>
          <input type="text" id="name" name="name" className="contact_form_input" onChange={handleChange} />
          <label htmlFor="phoneNumber" className="contact_form_label">
            Teléfono (WhatsApp)
          </label>
          <input type="text" id="phoneNumber" name="phoneNumber" className="contact_form_input" onChange={handleChange} />
          <label htmlFor="email" className="contact_form_label">
            Email
          </label>
          <input type="text" id="email" name="email" className="contact_form_input" onChange={handleChange} />
          <label htmlFor="company" className="contact_form_label">
            Empresa
          </label>
          <input type="text" id="company" name="company" className="contact_form_input" onChange={handleChange} />
          <label htmlFor="message" className="contact_form_label">
            Mensaje
          </label>
          <input type="text" id="message" name="message" className="contact_form_input contact_form_input_message " onChange={handleChange} />
          <div className="contact_form_recaptcha">
            <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_KEY} onChange={onChange} />
          </div>
          <button className={`contact_form_send_message ${(validUser === false || isValid == false) && `button_disabled`}`} disabled={validUser === false && isValid == false}>
            Enviar mensaje
          </button>
        </form>
      )}
    </>
  );
};

export default ContactForm;
